import React from 'react';
import { Modal, TextInput, LongTextInput } from 'hyperdb-utils';

const ModalForward = ({
  messageToForward, loading = false,
  onChange, onSubmit, onClose,
}) => {
  return (
    <Modal title="Forward message" onClose={ onClose } onAccept={ onSubmit } loading={ loading }>
      <fieldset>
        <TextInput
          label="Subject"
          name="subject"
          value={ messageToForward.subject }
          onChange={ onChange.bind(null, 'subject') }
        />
        <TextInput
          label="Recipient"
          name="recipient"
          value={ messageToForward.recipient }
          onChange={ onChange.bind(null, 'recipient') }
        />
        <LongTextInput
          label="Message"
          name="body"
          value={ messageToForward.body }
          onChange={ onChange.bind(null, 'body') }
        />
      </fieldset>
    </Modal>
  );
};

export default ModalForward;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/components/ModalForward.jsx